<div class="page">
  <div class="page-container filter-wrapper">
    <em-box class="bg-white sticky top-0">
      <form
        [formGroup]="filterForm"
        class="filter-controls compact-theme flex gap-2"
      >
        <em-select
          formControlName="type"
          class="bg-white"
          [label]="'ACTIONS_TOGGLE_QUICK_FILTERS' | translate"
          [subscriptSizing]="'dynamic'"
        >
          <ng-container emPrefix
            ><em-icon name="filter_list"></em-icon
          ></ng-container>
          <em-option value="all">{{
            'SHARED_LABEL_ALL' | translate
          }}</em-option>
          <em-option value="custom">{{
            'PRODUCT_GROUP_CUSTOM_GROUPS' | translate
          }}</em-option>
          <em-option value="radar">{{
            'PRODUCT_GROUPS_COMPETITOR_RADAR_GROUPS_TITLE' | translate
          }}</em-option>
          <em-option value="gad">{{
            'PRODUCT_GROUPS_AUTOMATED_DISCOUNTS_GROUPS_TITLE' | translate
          }}</em-option>
        </em-select>

        <em-select
          formControlName="sortBy"
          class="bg-white"
          [label]="'SHARED_LABEL_SORT_BY' | translate"
          [subscriptSizing]="'dynamic'"
        >
          <ng-container emPrefix
            ><em-icon name="sort_by_alpha"></em-icon
          ></ng-container>
          <em-option value="name-asc">Name (A-Z)</em-option>
          <em-option value="name-desc">Name (Z-A)</em-option>
          <em-option value="type-asc">Type (A-Z)</em-option>
          <em-option value="type-desc">Type (Z-A)</em-option>
        </em-select>

        <em-input
          class="bg-white"
          formControlName="searchQuery"
          [label]="'SHARED_LABEL_SEARCH' | translate"
          [subscriptSizing]="'dynamic'"
          [floatLabel]="'always'"
        >
          <ng-container emPrefix
            ><em-icon name="search"></em-icon
          ></ng-container>
        </em-input>

        <em-primary-button
          class="ml-auto"
          [matMenuTriggerFor]="menu"
          [icon]="'add'"
          >{{ 'SHARED_LABEL_ADD_NEW' | translate }}
        </em-primary-button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="addNewGroup()">
            <span>{{ 'PRODUCT_GROUP_CUSTOM_GROUP' | translate }}</span>
          </button>
          <button mat-menu-item (click)="addRadarGroup(productGroups() || [])">
            <span>{{ 'NAV_COMPETITORS_RADAR' | translate }}</span>
          </button>
          <button
            mat-menu-item
            [disabled]="hasSpdGroup()"
            (click)="addAutomatedDiscountGroup()"
          >
            <span>Automated Discount</span>
          </button>
        </mat-menu>
      </form>
    </em-box>
  </div>
  <div class="page-container" style="max-width: 1000px">
    <div>
      @if (filteredGroups(); as filteredGroups) {
        <em-product-groups-list
          class="@container"
          [groups]="filteredGroups"
        ></em-product-groups-list>
      }

      @if (isLoadingGroups()) {
        <em-spinner [overContent]="true"></em-spinner>
      }
    </div>
  </div>

  @if (showSuggestedPlan()) {
    <em-suggested-plan [isFloating]="true"></em-suggested-plan>
  }
</div>
